var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,attrs:{"id":"btn-focus"},on:{"click":_vm.handleBtnClick}},[_c('img',{attrs:{"id":"default","src":_vm.getIcon,"alt":""}}),_c('img',{attrs:{"id":"hover","src":_vm.getIconHover,"alt":""}}),_c('div',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }